import cn from 'classnames';
import { FREE_PLAN_HOST_LIMIT } from '../constants.ts';
import styles from './HostUsageMeter.module.css';

const countFormat = new Intl.NumberFormat();

type Props = {
  /** Current enrolled host count (includes lighthouses and relays) */
  currentHostCount: number;
  className?: string;
};

export function HostUsageMeter({ currentHostCount, className }: Props) {
  const overLimit = currentHostCount > FREE_PLAN_HOST_LIMIT;
  const atLimit = currentHostCount >= FREE_PLAN_HOST_LIMIT;
  const nearLimit = !atLimit && currentHostCount >= FREE_PLAN_HOST_LIMIT * 0.9;

  return (
    <div className={className}>
      <p className="p-md mb-4">
        {`${countFormat.format(currentHostCount)} of ${countFormat.format(FREE_PLAN_HOST_LIMIT)} free hosts used`}
      </p>
      <meter
        aria-label="Free plan host usage"
        aria-valuetext={`${countFormat.format(currentHostCount)} of ${countFormat.format(FREE_PLAN_HOST_LIMIT)} free hosts used`}
        min={0}
        max={FREE_PLAN_HOST_LIMIT}
        value={Math.min(currentHostCount, FREE_PLAN_HOST_LIMIT)}
        className={cn(styles.HostUsageMeter, {
          [styles.HostUsageMeter___nearLimit]: nearLimit,
          [styles.HostUsageMeter___atLimit]: atLimit,
        })}
      />
      {overLimit ?
        <p className={cn('p-sm mb-0 mt-8', styles.HostUsageMeter_status___alert)}>
          You’re over the free plan’s {FREE_PLAN_HOST_LIMIT}-host limit. Upgrade to Pro to enroll more hosts.
        </p>
      : atLimit ?
        <p className={cn('p-sm mb-0 mt-8', styles.HostUsageMeter_status___alert)}>
          You’ve reached the limit of {FREE_PLAN_HOST_LIMIT} hosts. Upgrade to Pro to enroll more hosts.
        </p>
      : null}
      {nearLimit ?
        <p className="p-sm mb-0 mt-8">You’re approaching the free plan’s {FREE_PLAN_HOST_LIMIT}-host limit.</p>
      : null}
    </div>
  );
}
